import { generateHookExports } from 'api/generateExports';
import { createCRUDService } from 'api/queryService';
import { API_CONFIG } from 'services/apiConfig';

let baseData = API_CONFIG.INTERNAL_COMMUNICATION;
const BASE_URL = baseData?.path;
const QUERY_KEY = baseData?.queryKey;

const internalCommunicationService = createCRUDService({
  baseUrl: BASE_URL,
  queryKey: QUERY_KEY,
});

export const {
  internalCommunicationList,
  internalCommunicationCreate,
  internalCommunicationGetById,
  internalCommunicationUpdate,
  internalCommunicationUpdateSpecific,
  internalCommunicationDownload,
  internalCommunicationDelete,
  internalCommunicationCount,
} = generateHookExports(internalCommunicationService, 'internalCommunication');
